import { gql } from '@apollo/client';

/**
 * 「保存换单打印操作日志」外部员工版本。
 * 与 SAVE_ORDER_REPRINT_LOG 字段结构一致；用 GraphQL 别名保持响应字段名 `saveOrderReprintLog` 不变，
 * 下游可直接复用 SaveOrderReprintLogResponse 类型。
 */
export const SAVE_ORDER_REPRINT_LOG_FOR_EXTERNAL_STAFF = gql`
    mutation SaveOrderReprintLogForExternalStaff(
        $hubId: Long
        $warehouseId: Long!
        $neutralTrackingNumber: String!
        $reprintTrackingNumber: String
        $trackingNumber: String
        $accountId: Long
        $status: Int!
        $failureType: Int
        $failureReason: String
        $processingTimeMs: Long!
    ) {
        saveOrderReprintLog: saveOrderReprintLogForExternalStaff(
            hubId: $hubId
            warehouseId: $warehouseId
            neutralTrackingNumber: $neutralTrackingNumber
            reprintTrackingNumber: $reprintTrackingNumber
            trackingNumber: $trackingNumber
            accountId: $accountId
            status: $status
            failureType: $failureType
            failureReason: $failureReason
            processingTimeMs: $processingTimeMs
        )
    }
`;
